import { nextFrame } from "../../library-js/animation/nextFrame";
import { ClassFlag } from "../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../library-js/dom-tools/ElementType";
import { OnClick } from "../../library-js/dom-tools/EventListeners";
import { DOMOrientation } from "../../library-js/dom/DOMOrientation";
import { MathX } from "../../library-js/math/MathX";

export class TabSelectors
{
  static readonly type = new ElementType( "tab--selectors" );
  static readonly select = new ElementType( "tab--select" );
  static readonly next = new ElementType( "tab--select--next" );
  static readonly previous = new ElementType( "tab--select--previous" );
  static readonly show = new ElementAttribute( "show" );
  static readonly elementsContainer = new ElementAttribute( "elements-container" );

  static applyOnDocument() 
  {
    TabSelectors.type.forAllInDoc( e => TabSelectors.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let selects = TabSelectors.select.queryAll( e );
    let selector = ElementAttribute.selector.from( e );

    let elementsContainer = e.parentElement;

    if ( TabSelectors.elementsContainer.in( e ) )
    {    
      elementsContainer = document.querySelector( TabSelectors.elementsContainer.from( e ) );
    }

    let elements = elementsContainer.querySelectorAll( selector );
    let next = TabSelectors.next.queryAll( e.parentElement );
    let previous = TabSelectors.previous.queryAll( e.parentElement );
    
    let getWithOffset = ( offset:number )=>
      {
        let current = TabSelectors.show.from( e );
        let index = selects.findIndex( s => TabSelectors.show.from( s ) === current );

        return TabSelectors.show.from( selects[ MathX.repeat( index + offset, selects.length ) ] );
      };

    next.forEach(
      ( n )=>
      {
        OnClick.add( n as HTMLElement, ()=>{ setActive( getWithOffset( 1 ) );  } );        
      }
    );

    previous.forEach(
      ( p )=>
      {
        OnClick.add( p as HTMLElement, ()=>{ setActive( getWithOffset( -1 ) );  } );        
      }
    );

    
    

    let visible = "block";
    let hidden = "none";

    let setActive = ( classValue:string, scroll:boolean = false ) => 
      {        
        let flag = new ClassFlag( classValue );
        TabSelectors.show.to( e, classValue ); 

        selects.forEach(
          ( s )=>
          { 
            if ( TabSelectors.show.from( s ) === classValue )
            {
              ClassFlag.active.set( s );
            }
            else
            {
              ClassFlag.active.removeFrom( s );
            }

          }
        );

        let activeElement:HTMLElement = null;

        elements.forEach(
          ( e:HTMLElement )=>
          {
            let isVisible = flag.in( e );    
            e.style.display = isVisible ? visible : hidden; 

            if ( isVisible )
            {
              activeElement = e;
            }
          }
        );

        if ( scroll )
        {
          (
            async ()=>
            {
              await nextFrame();

              let offset = DOMOrientation.isPortrait ? -150 : -100;
              TabSelectors.scrollToElementWithOffset( activeElement, offset );
            }
          )();

        }

        

      };
    
    selects.forEach(
      ( s )=>
      {
        
        OnClick.add( s as HTMLElement, 
          ()=>
          {
            console.log( "click", s ); 
            setActive( TabSelectors.show.from( s ), true );
          }
        )  
      }
    );


    setActive( TabSelectors.show.from( selects[ 0 ] ), false );
      
   


  }

  static scrollToElementWithOffset(  element: HTMLElement,  offsetPx: number, options?: { behavior?: ScrollBehavior }  ) 
  {
    let rect = element.getBoundingClientRect();
  
    let elementTopInDocument = rect.top + window.scrollY;
  
    let targetScrollY = elementTopInDocument + offsetPx;
    
    let behavior = options?.behavior ?? "smooth";

    window.scrollTo( {  top: targetScrollY,  behavior: behavior } );
  }
}
